import React, { useMemo, useRef } from 'react';

import cs from 'classnames';
import { AgGridReact } from 'ag-grid-react';
import { LicenseManager } from 'ag-grid-enterprise';

import { NATIVE_HEADER_GEOMETRY, applyHeaderMinWidths } from '../AGTable/lib/headerMinWidth';
import { applySkeletonRenderers, makeSkeletonRows, skeletonGetRowId } from '../AGTable/lib/helpers';

import '../AGTable/Table.scss';

LicenseManager.setLicenseKey(process.env.REACT_AG_GRID_KEY);

const AGBasicTable = ({
  customClassName,
  columnDefs = [],
  rowData,
  defaultColDef = {},
  gridRef,
  loading,
  skeletonSize = 25,
  getRowId,
  ...props
}) => {
  const isLoading = loading ?? rowData == null;

  const sizedColumnDefs = useMemo(
    () =>
      applySkeletonRenderers(
        applyHeaderMinWidths(columnDefs, defaultColDef, NATIVE_HEADER_GEOMETRY)
      ),
    [columnDefs, defaultColDef]
  );

  const skeletonRows = useMemo(() => makeSkeletonRows(skeletonSize), [skeletonSize]);

  const getRowIdRef = useRef(getRowId);
  getRowIdRef.current = getRowId;
  const getRowIdHandler = useMemo(
    () => skeletonGetRowId((params) => getRowIdRef.current?.(params)),
    []
  );

  return (
    <div className={cs('ag-theme-quartz h-full', customClassName)}>
      <AgGridReact
        ref={gridRef}
        columnDefs={sizedColumnDefs}
        rowData={isLoading ? skeletonRows : rowData}
        defaultColDef={defaultColDef}
        getRowId={getRowId ? getRowIdHandler : undefined}
        {...props}
      />
    </div>
  );
};

export default AGBasicTable;
